import {
  differenceInDays,
  differenceInWeeks,
  differenceInMonths,
} from 'date-fns';

export class DimensionHelper {
  static accumulateDimension(acc: string | number, x: string | number): string {
    return (acc ? `${acc} | ${x}` : x).toString();
  }

  static getDuration(
    start: string | undefined,
    end: string | undefined
  ): string {
    if (!start || !end) {
      return '';
    }
    const startDate = new Date(start);
    const endDate = new Date(end);
    const days = differenceInDays(endDate, startDate);
    if (days <= 34) {
      return `${days} days`;
    }

    const weeks = differenceInWeeks(endDate, startDate);
    if (weeks <= 13) {
      return `${Math.round(weeks)} weeks`;
    }
    const months = differenceInMonths(endDate, startDate);
    return `${Math.round(months)} months`;
  }

  static getAgeGroup(age: number | null): string {
    if (age === null) {
      return '';
    }
    if (age < 18) {
      return '1-17';
    } else if (age < 25) {
      return '18-24';
    } else if (age < 75) {
      const lower = 5 * Math.floor(age / 5);
      return `${lower}-${lower + 4}`;
    } else {
      return '75+';
    }
  }
}
